<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="6" cols="7">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb />
                </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header">
                                <h3>{{title}}</h3>
                            </div>
                            <b-row>
                                <b-col cols="4">
                                    <base-input :label="language_terms['NAME']" v-model="user.name" :disabled="!isShowBtn"></base-input>
                                </b-col>
                                <b-col cols="4">
                                    <base-input :label="language_terms['EMAIL']" v-model="user.email" :disabled="!isShowBtn"></base-input>
                                </b-col>
                                <b-col cols="4">
                                    <base-input :label="language_terms['MOBILE']" v-model="user.mobile" :disabled="!isShowBtn"></base-input>
                                </b-col>
                                <b-col cols="4">
                                      <base-input group :label="language_terms['PASSWORD']">
                                        <div class="input-group">
                                            <input :type="pwd_box_type" class="form-control" v-model="user.password">
                                            <div class="input-group-append" id="button-addon4">
                                                <button class="btn btn-outline-success" type="button" @click="togglePwdBoxType"><i class="fa fa-eye"></i></button>
                                            </div>
                                        </div>
                                    </base-input>
                                </b-col>
                                <b-col cols="4">
                                    <label class="form-control-label">{{language_terms['EMPLOYEE']}}</label>
                                    <employeeLookup v-bind:url="apiEmployeeLookup" v-on:selected="selectContact($event)" :lookupId="user.contact_code" :disabled="!isShowBtn"/>
                                </b-col>
                                <b-col cols="4">
                                    <label class="form-control-label">{{language_terms['ROLES']}}</label>
                                    <multiselect
                                            :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                            :placeholder="language_terms['SEARCH_ADD_TAG']"
                                            open-direction="bottom"
                                            label="code"
                                            track-by="code"
                                            :options="roles"
                                            text-field="name"
                                            :multiple="true"
                                            v-model="user.roles"
                                            :taggable="false"
                                            :disabled="!isShowBtn"
                                    ></multiselect>
                                </b-col>
                                <b-col cols="12" class="mb-3">
                                    <label class="form-control-label">{{language_terms['LOCATIONS']}}</label>
                                    <multiselect
                                        :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                        :placeholder="language_terms['SEARCH']"
                                        open-direction="bottom"
                                        label="code"
                                        track-by="code"
                                        :options="all_locations"
                                        text-field="name"
                                        :multiple="true"
                                        v-model="user.locations"
                                        :taggable="false"
                                        :disabled="!isShowBtn"
                                    ></multiselect>
                                </b-col>
                                <b-col cols="12">
                                    <b-form-checkbox class="mb-3" v-model="user.is_active" value="1" unchecked-value="0" :disabled="!isShowBtn">
                                        {{language_terms['IS_ACTIVE']}}
                                    </b-form-checkbox>
                                </b-col>                                
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <b-button class="transparent-btn"  @click="showFloatBtn" v-if="!isShowBtn">
                            <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="saveUser" v-if="isShowBtn">
                            <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancelUser" v-if="isShowBtn">
                            <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                        </b-button>
                        <b-button class="transparent-btn" @click="deleteUser" v-if="$route.params.id != '_new'">
                            <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import employeeLookup from "@/components/Autocomplete.vue";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

export default {
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            roles: state => state.users.roles,
            user_data:state => state.users.data,
            is_updated:state => state.users.is_updated,
            is_created:state => state.users.is_created,
            user_filter: state => state.users.filter,
            all_locations: state => state.locations.all_locations
        })
    },
    components: {
        Loading,
        employeeLookup
    },
    data(){
        return{
            loading:false,
            isShowBtn:false,
            title:"",
            pwd_box_type:"password",
            apiEmployeeLookup: apiRoutes["EMPLOYEE_LOOKUP"],
            user:{
                locations:[],
                roles:[],
                password:"",
                contact_code:"",
                contact_id:"",
                contact_name:"",
                name:"",
                handle:"",
                email:"",
                is_active:'0',
                email:"",
                mobile:""
            }
        }
    },
    methods:
    {
        togglePwdBoxType()
        {
            if(this.pwd_box_type == 'text')
            {
                this.pwd_box_type = 'password';
            }
            else
            {
                this.pwd_box_type = 'text'
            }
        },
        showFloatBtn()
        {
            this.isShowBtn = true
        },
        selectContact(obj)
        {
            if(obj)
            {
                this.user.contact_id = obj.contact_id
                this.user.contact_code = obj.code
                this.user.contact_name = obj.name

            }
        },
        async searchCustomer()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.user_filter)
            {
                filter = this.user_filter
            }
            await this.$store.dispatch('users/quickSearch', filter)

            this.loading = false
        },
        async saveUser()
        {
            this.loading = true
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("users/create", this.user);

                if(this.is_created)
                {
                    this.routeToMaster()
                }
            }
            else
            {
                await this.$store.dispatch("users/update", this.user);

                if(this.is_updated)
                {
                    this.routeToMaster()
                }
            }
            this.loading = false
        },
        routeToMaster()
        {
            this.$router.push("/users/master");
        },
        cancelUser()
        {
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/users/master")
            }
            else
            {
                location.reload();
            }
        },
        deleteUser()
        {
            alert("delete user")
        },
        async listRoles()
        {
            await this.$store.dispatch("users/fetchRoles", {})
        },
        async retrieveUser(handle)
        {
            await this.$store.dispatch("users/fetch", {handle: handle})
            this.user = this.user_data
        }
    },
    async mounted()
    {
        let id = this.$route.params.id
        if(id == '_new')
        {
            this.title = this.language_terms['NEW_USER']
            this.isShowBtn = true
        }
        else
        {
            this.title = id
            await this.retrieveUser(id)
        }

        await this.$store.dispatch("locations/listLocations", {})
        await this.listRoles()
    }
}
</script>
